import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  ITypeOfPaymentFetchParams,
  ITypeOfPayment,
  MN_TYPE_OF_PAYMENTS,
} from '@jobcost-monorepo/crud';

export default function TypeOfPaymentsPage() {
  return (
    <Grid<ITypeOfPayment, ITypeOfPaymentFetchParams>
      moduleName={MN_TYPE_OF_PAYMENTS}
      updateStore={false}
    ></Grid>
  );
}
